import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { Radio } from '../Input';
import { Wrapper } from '../Layout';
import { H4, Text } from '../Typography';
import { Card } from './Card';

interface ICardRadioProps {
  title: string;
  description: string;
  name: string;
  checked?: boolean;
  onChange: () => void;
  className?: string;
  dataCy?: string;
}

const StyledCard = styled(Card)<{ checked?: boolean }>`
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  padding: ${toRem(theme.space.lg)} ${toRem(theme.space.lg)};
  border-radius: ${toRem(12)};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  background-color: ${theme.color.white};
  gap: ${toRem(theme.space.sm)};
  cursor: pointer;

  p {
    color: ${theme.color.neutral[500]};
  }

  &:hover {
    border-color: ${theme.color.secondary[400]};
  }

  ${({ checked }) =>
    checked &&
    css`
      border-color: ${theme.color.secondary[400]};
    `}
`;

const HeaderWrapper = styled(Wrapper)`
  max-height: ${toRem(20)};
`;

const CardRadio: React.FC<ICardRadioProps> = ({ title, description, name, checked, onChange, className, dataCy }) => {
  const handleChange = () => {
    if (!checked) onChange();
  };
  return (
    <StyledCard className={className} onClick={handleChange} checked={checked} data-cy={dataCy}>
      <HeaderWrapper direction="row" justifyContent="space-between" width="100%" noWrap>
        <H4 fontWeight="semibold">{title}</H4>
        <Radio name={name} checked={checked} onChange={handleChange} />
      </HeaderWrapper>
      <Text size="small">{description}</Text>
    </StyledCard>
  );
};

export default CardRadio;
